import Dashboard from './../components/accounts/Dashboard.vue'
import Show from './../components/accounts/Show.vue'
import Create from './../components/accounts/Create.vue'
import Edit from './../components/accounts/Edit.vue'
import Test from './../components/accounts/Test.vue'
import Root from './../components/Root.vue'
export default {
  path: 'accounts',
  component: Root,
  children: [
    {
      path: '',
      name: 'admin.accounts.dashboard',
      component: Dashboard
    },
    {
      path: ':id/show',
      name: 'admin.accounts.show',
      component: Show
    },
    {
      path: 'create',
      name: 'admin.accounts.create',
      component: Create
    },
    {
      path: ':id/update',
      name: 'admin.accounts.edit',
      component: Edit
    },
    {
      path: ':id/test',
      name: 'admin.accounts.test',
      component: Test
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/accounts.js